import React, { useRef, useState, useEffect } from "react";
import { Circle, Line, Rect, Text } from "react-konva";

const NormalColumn = (props) => {
    const [hoverColumn, setHoverColumn] = useState(false);
    const [textWidth, setTextWidth] = useState(0);
    const textRef = useRef();

    const {
        position,
        circleRadius,
        handleDragMove,
        getDynamicFontSize,
        shapeRef,
    } = props;

    const angleRad = ((props.positionAngle - 90) * Math.PI) / 180;
    const outreach = props.values.outreach || 0;

    const fullArmLength = 0.75;
    const effectiveArmLength = fullArmLength * Math.max(1, outreach);
    const rectArmLength = fullArmLength * Math.max(0, outreach);

    const armX = 0;
    const armY = 0;

    const armTipX = armX + effectiveArmLength * Math.cos(angleRad);
    const armTipY = armY + effectiveArmLength * Math.sin(angleRad);

    const rectX = armX + rectArmLength * Math.cos(angleRad);
    const rectY = armY + rectArmLength * Math.sin(angleRad);

    const color = props.color === "#212529" ? "lightgray" : props.color;

    useEffect(() => {
        if (textRef.current) {
            const box = textRef.current.getClientRect();
            setTextWidth(box.width / props.stageScale);
        }
    }, [props.name, props.stageScale, hoverColumn]);


    return (
        <>
            {/* Arm Line */}
            <Line
                points={[
                    position.x + armX,
                    position.y + armY,
                    position.x + armTipX,
                    position.y + armTipY,
                ]}
                stroke={color}
                strokeWidth={circleRadius / 5}
            />

            {/* Lantern Box */}
            <Rect
                x={position.x + rectX}
                y={position.y + rectY}
                width={0.2}
                height={0.2}
                fill={color}
                rotation={props.positionAngle}
                offset={{ x: 0.1, y: 0.1 }}
            />

            {/* Optional Hover Text */}
            {hoverColumn && (
                <Text
                    ref={textRef}
                    x={position.x - (textWidth / 2)}
                    y={props.textPosY}
                    text={props.name}
                    fontSize={getDynamicFontSize()}
                    fill="black"
                    fontStyle="bold"
                    padding={5}
                    backgroundColor="gray"
                    opacity={0.75}
                    listening={false}
                />
            )}

            {/* Draggable Column Base */}
            <Circle
                x={position.x}
                y={position.y}
                rotation={props.positionAngle || 0}
                radius={circleRadius / 2}
                fill={color}
                draggable={props.selected}
                ref={shapeRef}
                onClick={() => props.selectColumn(props.id)}
                onTap={() => props.selectColumn(props.id)}
                onDragMove={handleDragMove}
                onDragEnd={(e) => props.updateColumn(e, props.i)}
                onMouseEnter={() => setHoverColumn(true)}
                onMouseLeave={() => setHoverColumn(false)}
            />
        </>
    );
};

export default NormalColumn;
